import { render, staticRenderFns } from "./ModalContinents.vue?vue&type=template&id=28c6bf08&scoped=true"
import script from "./ModalContinents.vue?vue&type=script&lang=js"
export * from "./ModalContinents.vue?vue&type=script&lang=js"
import style0 from "./ModalContinents.css?vue&type=style&index=0&id=28c6bf08&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6bf08",
  null
  
)

export default component.exports